import { isLandDevelopmentModel } from 'helpers/proForma';
import { handleExportProFormaToExcel, IExportProFormaToExcelParams } from './index';
import { handleExportLandDevelopmentToExcel, IExportLandDevelopmentToExcelParams } from './landDevelopment';

export type IExportProFormaWorkbookParams = IExportProFormaToExcelParams & IExportLandDevelopmentToExcelParams;

export const exportProFormaWorkbook = async (params: IExportProFormaWorkbookParams): Promise<void> => {
    if (isLandDevelopmentModel(params.proForma.proFormaModelId)) {
        await handleExportLandDevelopmentToExcel({
            proForma: params.proForma,
            usesSummary: params.usesSummary,
            sourcesSummary: params.sourcesSummary,
            disposition: params.disposition,
            returns: params.returns,
            residentialLotMixes: params.residentialLotMixes,
            otherRevenue: params.otherRevenue,
            salesSchedule: params.salesSchedule,
            sourceTypes: params.sourceTypes,
            showCents: params.showCents,
        });
        return;
    }

    await handleExportProFormaToExcel({
        proForma: params.proForma,
        operatingInfo: params.operatingInfo,
        incomeSummary: params.incomeSummary,
        usesSummary: params.usesSummary,
        sourcesSummary: params.sourcesSummary,
        cashFlows: params.cashFlows,
        disposition: params.disposition,
        returns: params.returns,
        showCents: params.showCents,
        includeGainLossToLease: params.includeGainLossToLease,
    });
};
